/* eslint-disable react/no-unescaped-entities */
import { shades } from "lib/miolo";
import { getYear } from "date-fns";
import mediaQueries from "../../lib/utils/layout/mediaQueries";

export default function Disclaimers() {
  const copyright = <span>© {getYear(new Date())}</span>;

  return (
    <section
      css={mediaQueries({
        display: "grid",
        gridRowGap: 30,
        gridColumnGap: 30,
        gridTemplateColumns: ["1fr", "1fr", "1fr", "1fr"],
        justifyContent: "center",
        width: [null, null, null, "100%"],
        maxWidth: 1140,
        margin: "0px auto",
        padding: ["0px 30px", 0, 0, 0],
        textAlign: ["center", "center", "left"],
      })}
    >
      <p
        css={{
          margin: 0,
          color: shades.greys.variants[4],
          fontWeight: 500,
          fontSize: 13,
          letterSpacing: 0.8,
          lineHeight: 1.66,
        }}
      >
        Disclaimers: {copyright} Morningstar - Os dados fundamentalistas e cotações de empresas Americanas ("Stocks")
        são fornecidos pela Morningstar, atualizados diariamente. Cotações de ativos Brasileiros são fornecidos pela{" "}
        {copyright} Enfoque Informações Financeiras LTDA, atualizados diariamente. Dados de moedas (Forex) são
        fornecidos pela {copyright} apilayer Data Products GmbH ("Currencylayer"), atualizados diariamente. Outros dados
        embutidos nas páginas das empresas tem origem direta dos sistemas dos órgãos regulatórios como CVM ("Comissão de
        Valores Mobiliários") / SEC ("U.S. Securities and Exchange Commission"), como também podem ser obtidos de
        comunicados oficiais das empresas em questão. O Fundamentei não se responsabiliza pela precisão/completude ou
        integridade das informações apresentadas no site ou em qualquer um de seus produtos. O Fundamentei também não se
        responsabiliza por quaisquer danos ou prejuízos decorrentes do uso dessas informações.
      </p>
    </section>
  );
}
